import React from "react";
import HelpCenterCard from "./HelpCenterCard";

const HelpCenter = ({
  title = "Help Center",
  description = "",
  heroImage = "",
  heroImageAlt = "",
  disclaimer = "",
  variant = "default",
  sections = [],
  onSelectSection,
}) => {
  return (
    <div className="flex min-h-[calc(100vh-83px)] flex-col px-12 pt-8">
      <div
        className={`mb-10 ${
          heroImage ? "grid items-center gap-8 md:grid-cols-[minmax(0,1fr)_minmax(16rem,24rem)]" : ""
        }`}
      >
        <div>
          <h2 className="text-3xl font-bold">{title}</h2>
          {description && (
            <p className="mt-4 max-w-3xl text-base leading-7 text-gray-700">
              {description}
            </p>
          )}
        </div>

        {heroImage && (
          <img
            src={heroImage}
            alt={heroImageAlt}
            className="mx-auto max-h-64 w-full rounded-2xl object-contain"
          />
        )}
      </div>

      {variant === "training" ? (
        <div className="pb-12">
          <div className="mx-auto max-w-5xl">
            <h3 className="mb-6 text-xl font-medium text-gray-900">
              General Guidance
            </h3>
            <div className="grid gap-8 md:grid-cols-3">
              {sections.slice(0, 3).map((section) => (
                <HelpCenterCard
                  key={section.id}
                  section={section}
                  variant="training"
                  onClick={() => onSelectSection(section)}
                />
              ))}
            </div>
          </div>

          <div className="mx-auto my-14 flex max-w-6xl items-center gap-6">
            <span className="h-px flex-1 bg-gray-400" aria-hidden="true" />
            <h3 className="whitespace-nowrap text-xl font-medium text-gray-900">
              Training By Age
            </h3>
            <span className="h-px flex-1 bg-gray-400" aria-hidden="true" />
          </div>

          <div className="mx-auto flex max-w-3xl flex-wrap justify-center gap-10">
            {sections.slice(3).map((section) => (
              <div key={section.id} className="w-full md:w-[calc(50%-1.25rem)]">
                <HelpCenterCard
                  section={section}
                  variant="training-age"
                  onClick={() => onSelectSection(section)}
                />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {sections.map((section) => (
            <HelpCenterCard
              key={section.id}
              section={section}
              onClick={() => onSelectSection(section)}
            />
          ))}
        </div>
      )}

      {disclaimer && (
        <p className="mx-auto mt-auto max-w-6xl pb-4 pt-16 text-xs leading-5 text-gray-700">
          <span className="font-semibold">Disclaimer: </span>
          {disclaimer}
        </p>
      )}
    </div>
  );
};

export default HelpCenter;
